import { gql } from '@apollo/client';

export const deleteControllerNote = gql`
  mutation deleteControllerNote($id: String) {
    deleteControllerNote(id: $id)
  }
`;
